import { fetcher } from '@commenda/utils';
import { ServiceRequestStatus } from '@prisma/client';
import { API_BASE_PATH } from './constants';

export async function updateServiceRequest({
  id,
  data,
}: {
  id: string;
  data: {
    status?: ServiceRequestStatus;
    isOnHold?: boolean;
    pauseReason?: string;
    corporationId?: number;
    assignedBusinessEntityIds?: number[];
    metadata?: { displayNameOverride?: string | null };
  };
}) {
  try {
    const res = await fetcher(
      `${API_BASE_PATH}/${id}`,
      {
        method: 'POST',
        body: data,
      },
      undefined
    );

    return res;
  } catch (err) {
    console.error('Error updating service request:', err);
    throw err;
  }
}
